var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show_Forwarder_Link)?_c('div',{staticClass:"spl-function-button",on:{"click":[function($event){if($event.ctrlKey||$event.shiftKey||$event.altKey||$event.metaKey)return null;return _vm.open_External_Tracker.apply(null, arguments)},function($event){$event.stopPropagation();}]}},[_vm._v(" "+_vm._s(_vm.linkData.providerName)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }